// extracted by mini-css-extract-plugin
export var title = "ter-dakar-itinerary-search-module-module--title--f9e0f";
export var widgetWrapper = "ter-dakar-itinerary-search-module-module--widgetWrapper--0cba6";